import CommonLocaleEN from '../domains/common/locales/en';
import EntriesLocaleEN from '../domains/entries/locales/en';
import GameLocaleEN from '../domains/game/locales/en';
import GamecenterLocaleEN from '../domains/gamecenter/locales/en';
import LobbyLocaleEN from '../domains/lobby/locale/en';
import MyContestsLocaleEN from '../domains/myContests/locales/en';
import QuickPickLocaleEN from '../domains/quickPick/locales/en';
import ManageLocaleEN from '../domains/managev2/locales/en';
import SurvivorLocaleEN from '../domains/quickPick/domains/survivor/locales/en';

export default {
  survivor: SurvivorLocaleEN,
  common: CommonLocaleEN,
  detail: {
    firstTeeTimeTbd: 'First Tee Time (TBD)',
    promoCallouts: {
      learnMore: 'Learn more',
      splitEntry: {
        title: 'Group Entries',
        available: 'Available now',
        subtitle: 'Split an entry with your crew. Everyone pays their share fee-free',
        modal: {
          title: 'Split an entry with up to 9 friends with Group Entries',
          sections: {
            enterContest: {
              title: 'Enter the contest',
              text: 'One player enters and pays the full entry fee, starting out owning 100% of the entry.',
            },
            inviteGroup: {
              title: 'Invite your group',
              text: 'From the My Entries screen, tap “Group,” search anyone with a Splash account, and invite up to 9 friends to share the entry.',
            },
            chooseCaptain: {
              title: 'Choose a captain',
              text: 'Decide who controls the picks. Only one person can hold pick control for the entry.',
            },
            acceptInvites: {
              title: 'Accept invites',
              text: 'Each friend receives an email and in-app notification. They must accept and pay before the first game locks.',
            },
            win: {
              title: 'Win',
              text: 'Winnings distribute automatically to every co-owner by their ownership %.',
            },
          },
          note: 'Group entry invites must be accepted before the contest starts.',
        },
      },
      marketplace: {
        title: 'Entry Marketplace',
        available: 'Available now',
        subtitle: 'Buy and sell entry shares mid-contest, from 1% to 100%.',
        modal: {
          title: 'A live market to buy and sell shares of survivor entries while the contest is running.',
          sections: {
            cashOut: {
              title: 'Cash out before the end',
              text: 'Sell some or all of your entry as the field narrows and the value climbs - you no longer have to ride it to the finish.',
            },
            buyIn: {
              title: 'Buy into a live entry',
              text: 'Purchase a share of a strong entry for the payout upside, or to take over pick control.',
            },
            sellPartial: {
              title: 'Sell all or part of your entry',
              text: 'Buy or sell a share as small as 1% of an entry. Majority owner (over 50%) holds the picks.',
            },
            knowWorth: {
              title: 'Know what it’s worth',
              text: 'The Splash Estimate shows each entry’s current value so you can price offers with confidence.',
            },
            sellOneTap: {
              title: 'Sell in one tap',
              text: 'Receive bids or name your price.',
            },
          },
          note: 'Marketplace opens after Week 1',
        },
      },
    },
    header: {
      title: {
        owner: '<link>{{owner}}</link> • Locks',
        adminOwner: 'Splash • Locks',
      },
      info: {
        prize: 'Prizes',
        entry: 'Entry',
        entries: 'Entries',
        deadline: 'Entry deadline',
      },
      actions: {
        copy: 'Share contest',
        new__hasPlural: {
          one: 'Add entry',
          other: 'Add entries',
        },
        makePicks: 'Make picks',
        enterContest: 'Enter contest',
        view: 'View contest',
        edit: 'Edit contest',
        editEntrants: 'View entrants',
        manage: 'Manage contest',
      },
    },
    locationInfo: {
      contestTypes: {
        team_pick_em: "Pick'Em",
        team_survivor: 'Survivor',
        player_tier: 'DFS',
        player_category: 'DFS',
        player_one_and_done: 'O&D',
        quick_picks: 'QuickPicks',
        player_survivor: 'Player Survivor',
        squares: 'Squares',
        target_score_bingo: 'Target Score',
        wins_pool: 'Wins',
        shares: 'Shares',
        team_brackets: 'Brackets',
      },
      titleUknown: 'You might be in a restricted location',
      titleKnown: 'You are in a restricted location ({{locationState}})',
      copyLobby:
        'Your current location {{locationState}} prevents you from making new entries in {{invalidContestTypes}} Contests. <0>Check our map</0> to view where you can play.',
      copyContestDetail:
        'Your current location {{locationState}} prevents you from making new entries in {{invalidContestTypes}} Contests. <0>Check our map</0> to view where you can play, or <1>go back to the lobby</1> to view more contests.',
      copyContestDetailAppend:
        'You are able to continue making picks in the contests that you currently have entries in.',
      checkLocationButtonLabel: 'Recheck location',
    },
    tabs: {
      detail: 'Contest Details',
      entrants: 'Entrants',
      posts: 'Posts',
    },
    about: {
      title: 'About this contest',
      info: {
        sport: 'League',
        contestType: 'Contest Type',
        creator: 'Creator',
        adminCreator: 'Splash',
        slate: 'Slate',
        multiEntry: 'Multi-Entry',
        entryMarketplace: 'Entry Marketplace',
        entryMarketplaceValue: {
          enabled: 'Yes',
          disabled: 'No',
        },
        yes: 'Yes ({{entries}})',
        no: 'No',
        entryDeadline: 'Entry Deadline',
        entryDeadlineTooltip:
          'Deadline for which all entrants must enter the contest. After this deadline, no entries will be accepted. Your entry deadline is for {{slateName}}',
        pickDeadline: 'Pick Deadline',
        pickDeadlineKnockoutStage: 'Pick Deadline (Knockout Stage)',
        pickDeadlineTooltip:
          'When all entrants must finalize their picks for each week. If your pick deadline is before your entry deadline for the first slate, the pick deadline will use that deadline for the first slate only.',
        pickDeadlineValue: {
          game: 'Game Start',
          slate: 'Slate Start',
          tournament: 'Tournament Start',
          dateTime: "ccc '@' h:mm a 'for {{slateName}}'",
          slateForCurrentSlate: 'Slate Start for {{slateName}}',
        },
      },
      game: {
        action: 'View all',
        modal: {
          today: 'Today',
          tomorrow: 'Tomorrow',
          title: 'All {{slateLabel}}',
          nogames: 'No games for this Slate.',
          collapse: {
            show: 'Show more',
            hide: 'Show less',
          },
        },
      },
    },
    appPromo: {
      title: 'Never miss out on the action!',
      subtitle:
        'Download the Splash Sports mobile app and turn on notifications to get pick reminders, the most up-to-date gameplay experience, social features, and additional payment methods!',
    },
    entries: {
      title: 'My entries {{status}}',
      noData: "You don't have any entries.",
      viewAll: 'View all entries',
      error: 'There was an issue while loading your entries',
      entry: {
        title: 'Entry',
        option: {
          edit: 'Edit picks',
          make: 'Make picks',
          view: 'View picks',
          withdraw: 'Withdraw entry',
          editName: 'Edit name',
        },
        withdrawalModal: {
          title: 'Are you sure you want to withdraw this entry ?',
          description:
            'By withdrawing your entry the entry fee will be credited back to your account.',
          descriptionEO:
            'By withdrawing your entry, your entry will no longer be eligible to compete in this contest.',
          cancel: 'Cancel',
          withdraw: 'Withdraw',
          error: {
            title: 'Unable to make a withdrawal to this entry.',
            message: 'Please try again.',
          },
          success: {
            message: 'Withdrawal was successfull.',
          },
        },
      },
    },
    prizes: {
      title: 'Prize payouts',
      modalTitle: 'Payout details',
      tooltip: {
        segmentedPayouts:
          '<text><b>Overall payouts</b> will be made at the end of the contest. <br></br> <b>Segment payouts</b> will be made at the end of each segment.</text>',
        payoutSlatesWeek:
          '<text><b>Overall payouts</b> will be made at the end of the contest. <br></br><b>Weekly payouts</b> will be made at the end of each week.</text>',
        payoutSlatesTournament:
          '<text><b>Overall payouts</b> will be made at the end of the contest. <br></br><b>Tournament payouts</b> will be made at the end of each tournament.</text>',
        payoutSlatesSlate:
          '<text><b>Overall payouts</b> will be made at the end of the contest. <br></br><b>Slate payouts</b> will be made at the end of each slate.</text>',
        overallPayouts:
          '<text><b>Prize payouts</b><br></br>This contest will only have payouts made to the winners at the end of the contest.</text>',
        resizable:
          '<text><flex><b>Resizable prizes</b> <icon></icon> </flex> If the contest does not fill, the payout amounts will be resized.</text>',
        guaranteed:
          '<text><flex><b>Guaranteed prizes</b> <icon></icon> </flex> The payout amount will not change if the contest does not fill.</text>',
        guaranteedPlus:
          '<text><flex><b>Guaranteed Plus</b> <icon></icon> </flex> The payout amounts, including bonus prizes, are guaranteed and will not change if the contest does not fill.</text>',
        standard:
          '<text><flex><b>Resizable prizes</b> <icon></icon> </flex> The payout does not filled it will be canceled and all entrants will be refunded their entry fee.</text>',
      },
      resizableContest: `If this contest does not fill, the payout amounts will be resized.`,
      standardContest:
        'If this contest does not fill, it will be canceled and all entrants will be refunded their entry fee.',
      guaranteedContest:
        'This is a guaranteed contest. The payout amounts will not change if the contest does not fill.',
      guaranteedPlusContest:
        'This contest is eligible for bonus prizes. Guaranteed bonus prizes may be added at Splash Sports’ sole discretion. Splash Sports Service fee not to exceed 10% (with or without guaranteed bonuses).',
      survivorContest:
        'This contest follows a winner-takes-all format, meaning only one participant will be declared the winner and receive the entire prize. In the event of multiple winners, the prize will be divided equally among all the winners.',
      otherContests:
        'In this contest, if two or more entrants end up with the same score or position, they will share the payout amount for the positions they tied for. For instance, if two entrants tie for the first position, they will each receive half of the first place payout amount along with the second place payout amount. The prize will be divided equally among all tied participants.',
      multiplierContest:
        'In this contest, if two or more entrants end up with the same score or position, they will share the payout amount for the positions they tied for.',
      segmentedPayouts: {
        title: 'This contest has an overall contest payout and contest segment payouts.',
        footer:
          'If this contest does not fill, the payout amounts for both the overall contest payout and the contest segment payouts will be resized.',
      },
      entryRevival: {
        title: 'Entry Revival',
        bonus: 'Bonus added: ',
        bonusInfo: 'The entry revival deadline has passed. All prizes are finalized.',
        potentialBonus: 'Potential bonus: ',
        potentialBonusInfo:
          'This contest has entry revivals enabled. The prize payouts do not include all potential entry revivals. The prizes will finalize once the entry revival deadline has passed.',
        revivalRules: 'View entry revival rules',
      },
      resizingMode: {
        resizable: 'Resizable',
        guaranteed: 'Guaranteed',
        guaranteedPlus: 'Guaranteed Plus',
        standard: 'Non-guaranteed',
      },
      slatePayouts: {
        title: 'This contest has an overall contest payout and payouts for each {{slateLabel}}.',
        footer:
          'If this contest does not fill, the payout amounts for both the overall contest payout and the {{slateLabel}} payouts will be resized.',
      },
      action: {
        view: 'View payout details',
        link: 'View contest resizing rules',
      },
      tabs: {
        overall: 'Overall',
        segments: 'Segments',
        slatePayoutWeek: 'Weeks',
        slatePayoutTournament: 'Tournaments',
        slatePayoutSlate: 'Slates',
      },
    },
    schedule: {
      title: {
        multiSlate: 'Schedule',
        tournament__hasPlural: {
          one: '1 Tournament',
          other: '{{count}} Tournaments',
        },
        week__hasPlural: {
          one: '1 Week',
          other: '{{count}} Weeks',
        },
        slate__hasPlural: {
          one: '1 Slate',
          other: '{{count}} Slates',
        },
      },
      action: {
        segment: 'View full schedule',
        tournament: 'View all tournaments',
        games: 'View all games',
      },
      tabs: {
        overall: 'Segments ({{value}})',
        tournaments: 'Tournaments ({{value}})',
        weeks: 'Weeks ({{value}})',
        slates: 'Slates ({{value}})',
      },
      table: {
        tournamentName: '{{segmentName}} ({{count}} tournaments)',
        weekName: '{{segmentName}} ({{count}} weeks)',
        slateName: '{{segmentName}} ({{count}} slates)',

        singleTournamentName: '{{name}} ({{count}} tournaments)',
        singleWeekName: '{{name}} ({{count}} games)',
        singleSlateName: '{{name}} ({{count}} slates)',
        date: 'Starts {{value}}',
      },
    },
    entrants: {
      title: 'Entrants',
      list: {
        following: 'Following',
        followsYou: 'Follows you',
        mutuallyFollowing: 'Mutually following',
      },
      action: 'Follow',
      modal: {
        title: 'All entries',
        seeAll: 'See all',
      },
      notification: {
        error: 'Failed to follow user. Please try again.',
      },
    },
    scoringAndRules: {
      title: 'Scoring & Rules',
    },
    contestSettings: {
      title: 'Contest settings',
      label: {
        pickObjective: 'Pick objective',
        picksPerSlate: 'Picks per {{slateLabel}}',
        teamUseLimit: 'Team use limit',
        playerUseLimit: 'Player use limit',
        resetTeams: 'Reset teams for playoffs',
        doublePickWeeks: 'Double pick {{slateLabel}}s',
        flexibleDoublePicks: 'Flexible double picks',
        automaticPicks: 'Automatic picks',
        contestRevivals: 'Contest revivals',
        entryLives: 'Entry lives',
        entryRevival: 'Entry revival (buy backs)',
        perSeason: 'Per season',
        perSegment: 'Per segment',
        alternates: 'Alternate picks',
        tiebreaker: 'Tiebreaker',
        pickScoring: 'Pick Scoring',
      },
      tooltip: {
        pickObjective:
          'Decides whether the objective of your contest is to pick winners or losers.',
        picksPerSlate: 'The number of picks you are required to make each {{slateLabel}}.',
        teamUseLimit: 'The number of times each team can be selected.',
        playerUseLimit: 'The number of times each player can be selected.',
        resetTeams: 'All playoff teams will be made available again once the playoffs start.',
        doublePickWeeks: '{{slateLabel}}s that require two picks to be made.',
        flexibleDoublePicks:
          'Weeks that require two picks to be made if a selected percentage or more of the total entries remain alive.',
        automaticPicks:
          'A predetermined team selection that gets submitted if an entrant does not make a pick before the pick deadline.',
        contestRevivals:
          'If all remaining entries are eliminated in the same slate, the contest is revived and continues.',
        entryLives: 'The number of lives each entry is assigned before the start of the contest.',
        entryRevival:
          'Allows entrants to pay a fee to revive their eliminated entry in the contest.',
        alternates:
          'A selection that will become your primary pick if your original pick does not play.',
        tiebreaker:
          "The tiebreaker will be the sum total of the seeds of each entrant's picks. The highest seed total wins the tiebreaker and first prize.",
        tiebreakerCumulativeWinMargin:
          'The tiebreaker will be the cumulative win margin of each entrant’s picks.',
        tiebreakerSlate:
          'Entrants guess the total score of the final game of the week. Closest guess wins any tie for that week.',
        pickScoring:
          'Determines whether picks are graded by picking straight-up winners or winners who cover the spread.',
      },
      values: {
        pickWinners: 'Pick Winners',
        pickLosers: 'Pick Losers',
        enabled: 'Enabled',
        disabled: 'Disabled',
        once: 'Once',
        twice: 'Twice',
        unlimited: 'Unlimited',
        times: '{{count}} times',
        totalLives__hasPlural: {
          one: '{{count}} Life',
          other: '{{count}} Total Lives',
        },
        enabledWithMax: 'Enabled (max of {{max}})',
        perSegment: 'per segment',
        perSeason: 'per season',
        straightUp: 'Straight up',
        againstTheSpread: 'Against the spread',
      },
      buttons: {
        viewMoreInfo: 'View more info',
        gotIt: 'Got it',
      },
      modal: {
        flexibleDoublePicks: {
          title: 'Flexible double picks enable if',
          entrantsRemain: '{{percentage}}% or more entrants remain',
        },
        entryRevival: {
          title: 'Entry revival settings',
          revivalDeadline: 'Revival deadline:',
          revivalFee: 'Revival fee:',
          revivalsPerEntry: 'Revivals per entry:',
          deadlineLabel: 'Before the start of:',
        },
      },
    },
  },
  enterContest: {
    error: {
      default: {
        title: 'Could not join contest',
        message: 'There was an error joining the contest. Please try again later.',
      },
      beginnerOnly: {
        title: 'Beginner Only Contest',
        message:
          'You are no longer a beginner user, and therefore are unable to join this beginner only contest. Check out the <legalLink>house rules</legalLink> for our user classification definitions!',
      },
    },
  },
  game: GameLocaleEN,
  gamecenter: GamecenterLocaleEN,
  lobby: LobbyLocaleEN,
  myContests: MyContestsLocaleEN,
  entries: EntriesLocaleEN,
  quickPick: QuickPickLocaleEN,
  manage: ManageLocaleEN,
  createContest: {
    success: {
      invite: 'Invite',
      inviteMembers: 'Invite members',
      viewInvite: 'View contest',
    },
    redirecting: {
      title: 'We are now redirecting you to the contest.',
      description: 'This will take a few seconds.',
    },
  },
  contestInviteStatus: {
    accepted: 'accepted',
    declined: 'declined',
  },
};
